var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M.002 11.677l.94-.94 11.562 11.56-.94.941z","key":0}),React.createElement("path",{"d":"M.005 11.56L11.566 0l.94.94L.947 12.5z","key":1})]);
}

ChevronLeft.defaultProps = {"viewBox":"0 0 12.5 23.24"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
